<script setup>
defineProps({
	leftDisabled: Boolean,
	rightDisabled: Boolean
});

const emit = defineEmits(['slide']);

function handleSlide (direction, disabled) {
	if (!disabled) {
		emit('slide', direction);
	}
}
</script>

<template>
  <div class="abCalendarWrapper__sliders">
    <div
      role="button"
      data-direction="left"
      :class="[
        'abCalendarWrapper__slider',
        'abCalendarWrapper__slider--left',
        { 'abCalendarWrapper__slider--disabled': leftDisabled },
      ]"
      @click="handleSlide('left', !!leftDisabled)"
    >
      <span class="icon icon-chevron-left" />
    </div>

    <div
      role="button"
      data-direction="right"
      :class="[
        'abCalendarWrapper__slider',
        'abCalendarWrapper__slider--right',
        { 'abCalendarWrapper__slider--disabled': rightDisabled },
      ]"
      @click="handleSlide('right', !!rightDisabled)"
    >
      <span class="icon icon-chevron-left" />
    </div>
  </div>
</template>
